<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box m-h-700">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">單日連線列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body form-inline">
            <div class="row" v-if="roleType !== 10">
              <div class="col-xs-12 col-sm-6">
                <div class="form-group">
                  <select class="form-control h-38" v-model="statusSelect">
                    <option value="99">== 連線狀態 ==</option>
                    <option value="1">建立</option>
                    <option value="2">中斷</option>
                  </select>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 text-right pull-right">
                <div class="form-group input-group time-box pull-right">
                  <date-time-picker :date="date" :option="dateoption" :limit="dateLimit"></date-time-picker>
                  <!--<input type="text" class="form-control time-picker" id="start-box" placeholder="起始時間">-->
                  <!--<input type="text" class="form-control time-picker" id="end-box" placeholder="結束時間">-->
                  <span class="input-group-btn">
                  <button class="btn btn-default submit-btn btn-search" type="button"
                          id="search3" style="height: 36px" @click="clickSearch()">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
                </div>
              </div>
            </div>
            <!--<div class="form-group" v-if="brandSelect !== 99 && brandSelect !== '99' && storeBrief.length > 1">-->
              <!--<select class="form-control h-38" v-model="storeSelect">-->
                <!--<option v-for="store in storeBrief" :value="store.value">-->
                  <!--{{store.label}}-->
                <!--</option>-->
              <!--</select>-->
            <!--</div>-->
            <!-- /.box-body -->
            <mqtt-table :isSearch="isSearch" :date="date.time" :statusSelect="statusSelect"></mqtt-table>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import mqttTable from './Temp/MqttSearchTemp.vue'
import moment from 'moment'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
export default {
  name: 'Tables',
  data () {
    return {
      roleType: 0,
      name: '',
      statusSelect: 99,
      isSearch: {
        active: false
      },
      // date
      date: {
        time: moment().format('YYYY-MM-DD')
      },
      dateLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      ],
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      }
    }
  },
  components: {
    'date-time-picker': datetimePicker,
    'mqtt-table': mqttTable
  },
  methods: {
    clickSearch () {
      this.isSearch.active = true
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  mounted () {
    this.clickSearch()
  }
}
</script>

<style scpoed>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}
.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}
.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
</style>



// WEBPACK FOOTER //
// MqttSearch.vue?ac5616b4